import { EventService } from '@go-modules/services/event/event.service';
import { FallbackRouteService } from '@dashboard/app/services/fallback-route.service';
import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';
import { GoModalService } from '@go-modules/services/go-modal/go-modal.service';
import { SessionTimeoutDialogComponent } from '@go-modules/components/dialogs/session-timeout/session-timeout.component';

export interface AppSessionManagerConfig {
	user: any;
}

export class AppSessionManagerService {
	public static PROVIDER_NAME: string = 'goreact';
	public appSessionManagerConfig: AppSessionManagerConfig;
	public modalOpen = false;

	/* @ngInject */
	constructor (
		public goModal,
		public $window,
		private ngxFallbackRouteService: FallbackRouteService,
		private ngxGoModalService: GoModalService
	) { }

	/**
	 * Handles configure.
	 *
	 * @returns {void}
	 */
	public configure (appSessionManagerConfig: AppSessionManagerConfig, eventService: EventService): void
	{
		if (this.appSessionManagerConfig) return;

		// Set user for fallback key
		this.ngxFallbackRouteService.setUser(appSessionManagerConfig.user);

		// handle session timeout
		eventService.listen(EVENT_NAMES.AUTH_ENDED).subscribe(() => {
			if (!this.modalOpen) {
				this.modalOpen = true;
				this.ngxGoModalService.open(SessionTimeoutDialogComponent, false, {
					data: {
						user: appSessionManagerConfig.user
					}
				}).afterClosed().subscribe(() => {
					// Always completely reload, so people don't stay on old versions of the app since
					// we deploy everyday
					this.modalOpen = false;
					this.$window.location.reload();
				});
			}
		});

		this.appSessionManagerConfig = appSessionManagerConfig;
	}

	public reset () {
		this.appSessionManagerConfig = null;
	}
}
